import Equipment from '../../models/Equipment';
import { ROUTES } from '../../../../config/routes';
import translations from './locales';

const xd38iii = new Equipment({
  id: 'xd38iii',
  name: 'XD38III',
  displayName: { main: 'XD38', accent: 'III' },
  path: ROUTES.xd38iiiIntro,
  assetDirectory: '/Equipment/xd38iii',
  translations,
  image: { file: 'machine.png', width: 1508, height: 1043 },
  video: {
    file: 'introduction.mp4',
    poster: 'video-poster.png',
    fallbackLanguage: 'en',
    files: { ko: 'introduction.mp4', en: 'introduction-en.mp4' },
  },
  catalog: {
    fallbackLanguage: 'en',
    files: { ko: 'catalog.png', en: 'catalog-en.png', zh: 'catalog-zh.png' },
  },
  badges: [
    { id: 'diameter', valueKey: 'diameterTag' },
    { id: 'spindle', value: '6,500 rpm' },
  ],
  metrics: [
    { id: 'diameter', labelKey: 'specifications.maxDiameter.label', value: 'Ø38', unit: 'mm' },
    { id: 'spindle', labelKey: 'specifications.mainSpindle.label', value: '6,500', unit: 'rpm' },
    { id: 'stroke', labelKey: 'guideBushStroke', value: '320', unit: 'mm' },
    { id: 'cross', labelKey: 'crossPower', value: '2.2', unit: 'kW' },
  ],
  features: ['thermal', 'guideBush', 'backTools'],
  specifications: [
    { id: 'nc', value: 'Fanuc 0i-TF Plus / Siemens 828D' },
    { id: 'maxDiameter' },
    { id: 'z1Stroke' },
    { id: 'mainSpindle', value: '6,500 rpm · FANUC: 5.5 / 7.5 kW · Siemens: 23 kW' },
    { id: 'turningTools', value: '6 × (□16 mm)' },
    { id: 'frontTools', value: '5 × (ER20)' },
    { id: 'crossTools', value: '6 × (ER16)' },
    { id: 'crossSpeed', value: '6,000 rpm · FANUC: 2.2 kW · Siemens: 2.13 kW' },
    { id: 'subSpindle', value: '6,500 rpm · FANUC: 2.2 / 5.5 kW · Siemens: 23 kW' },
    { id: 'backTools', value: 'Y2: 8 × (ER16)' },
    { id: 'backSpeed', value: '6,000 rpm · FANUC: 1.0 kW · Siemens: 2.13 kW' },
    { id: 'dimensions', value: 'FANUC: 2,690 × 1,580 × 1,820 mm / Siemens: 3,100 × 1,650 × 1,820 mm' },
    { id: 'weight', value: '4,690 kg' },
    { id: 'power' },
    { id: 'air', value: '120–150 L/min' },
  ],
  specificationNoteKey: 'powerNote',
  options: ['backSix', 'backCross', 'backDrivenEight', 'offCenter', 'crossDriven', 'crossAngle'],
  optionImages: {
    backCross: 'backCross.png',
    backDrivenEight: 'backEight.png',
    offCenter: 'offCenter.png',
  },
});

export default xd38iii;
